<template>
  <HubContainer id="companySupportHub">

    <template v-if="atLeastDistributor">
      <HubSection large icon="icon/hub/failed-sales.svg"
                  :title="$t('advanced_navigation.failed_sales')"
                  :description="$t('advanced_navigation.failed_sales_description')"
                  :buttonAction="goToFailedSales">
      </HubSection>

      <HubSection large icon="icon/hub/test-sales.svg"
                  :title="$t('advanced_navigation.test_sales')"
                  :description="$t('advanced_navigation.test_sales_description')"
                  :buttonAction="goTotestsSales">
      </HubSection>

      <HubSection large icon="icon/hub/sale-creation.svg"
                  :title="$t('advanced_navigation.create_sale')"
                  :description="$t('advanced_navigation.create_sale_description')"
                  :buttonAction="goToCreateTestsSale">
      </HubSection>

      <HubSection large icon="icon/hub/role-permission.svg" v-if="$store.getters.loggedUserHasModifyPermission"
                  :title="$t('settings.permissions')"
                  :description="$t('settings.permissions_description')"
                  :buttonAction="goToRolePermission">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "companySupportHub",

    components: {HubSection, HubContainer},

    mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.support";
      this.$store.state.pageIcon = "/icon/info.svg";
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
      atLeastDistributor() {
        return this.$store.getters.loggedUserHasDistributor;
      },
      exactlyDistributor() {
        return this.$store.state.loggedUser.isDistributor;
      },
      branch() {
        return this.$store.state.contextBranch;
      },
      company() {
        return this.$store.state.contextCompany;
      },
      getContextName() {
        if (this.branch && this.company) {
          return this.company.name;
        }
        return "";
      }
    },

    methods: {
      goToFailedSales() {
        this.$router.push(this.$router.buildContext("/failed-sales"));
      },
      goTotestsSales() {
        this.$router.push(this.$router.buildContext("/test-sales"));
      },
      goToCreateTestsSale() {
        this.$router.push(this.$router.buildContext("/create-test-sale"));
      },
      goToRolePermission() {
        this.$router.push(this.$router.buildContext("/role-permissions"));
      }
    }
  }
</script>